// App.js
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Home from './pages/home';
import Terms from './pages/terms';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/terminos-y-condiciones" element={<Terms />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
